"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = exports.danger = exports.valid = exports.focus = exports.disabled = exports.enabled = void 0;

var _core = require("@emotion/core");

var _border = require("../border");

var enabled = function enabled(_ref) {
  var theme = _ref.theme;
  return (0, _core.css)(_templateObject(), (0, _border.thin)({
    theme: theme
  }), theme.bColorneutral05);
};

exports.enabled = enabled;

var disabled = function disabled(_ref2) {
  var theme = _ref2.theme;
  return (0, _core.css)(_templateObject2(), (0, _border.thin)({
    theme: theme
  }), theme.bColorneutral04);
};

exports.disabled = disabled;

var focus = function focus(_ref3) {
  var theme = _ref3.theme;
  return (0, _core.css)(_templateObject3(), (0, _border.thin)({
    theme: theme
  }), theme.bColorsecondary05);
};

exports.focus = focus;

var valid = function valid(_ref4) {
  var theme = _ref4.theme;
  return (0, _core.css)(_templateObject4(), (0, _border.thin)({
    theme: theme
  }), theme.bColorsuccess);
};

exports.valid = valid;

var danger = function danger(_ref5) {
  var theme = _ref5.theme;
  return (0, _core.css)(_templateObject5(), (0, _border.thin)({
    theme: theme
  }), theme.bColordanger);
};

exports.danger = danger;

var warning = function warning(_ref6) {
  var theme = _ref6.theme;
  return (0, _core.css)(_templateObject6(), (0, _border.thin)({
    theme: theme
  }), theme.bColorwarning);
};

exports.warning = warning;